module.exports = __webpack_public_path__ + "img/BentonSansBBVA-Book.01009e72.svg";